import { render, staticRenderFns } from "./GalleryDetail.vue?vue&type=template&id=c46254c4&scoped=true"
import script from "./GalleryDetail.vue?vue&type=script&lang=js"
export * from "./GalleryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46254c4",
  null
  
)

export default component.exports